module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Acknowledgment#frontmatter01"
    }
  }, [_c('b', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter01#chapter01"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" Welcome home")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter02#chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" Planning for both a future and failure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rchapter02section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter02section01#chapter02section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Profile 1: Michelle, Chicago: the future of cities")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter03#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" Choosing home")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" Triaging your situation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rchapter04section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter04section01#chapter04section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Profile 2: Bruce and Kathy, western Massachusetts: The open house")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter05#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" Staying warm and keeping cool")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter06#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" The basics of daily life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter07#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v(" Getting around")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rchapter07section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter07section01#chapter07section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Profile 3: Risa and Pattiebuff: Doing it over again")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter08#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" Growing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rchapter08section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter08section01#chapter08section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Profile 4: Aaron and Jennifer Newton: Working it Through")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter09"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter09#chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v(" All creatures great and small")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v(" Marriage and family")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rchapter10section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter10section01#chapter10section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Profile 5: Lisa and Patti: Water in the rain barrel")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter11"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v(" Father and Mother and Uncle John: tribalism and family")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v(" Is your love enough?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v(" Skills, work and money")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14")]), _vm._v(" Security matters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15")]), _vm._v(" Putting it together")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rchapter15section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter15section01#chapter15section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Profile 6: Gerri")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryf",
    attrs: {
      "id": "rbackmatter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Index#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Index")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryf",
    attrs: {
      "id": "rbackmatter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Abouttheauthor#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0